import React from 'react';
import PropTypes from 'prop-types';
import jwtDecode from 'jwt-decode'; 
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({
  children,
  hasToken,
  hasProfile,
  consent
}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  if (!hasToken) {
    if (currentPath === '/login') return children;
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const isOnboarding = currentPath.startsWith('/onboarding');
  
  if (!consent && !isOnboarding) {
    if (currentPath === '/consent-refused') return children;
    return <Navigate to="/consent-refused" state={{ from: location }} replace />;
  }

  const isProfileExempt = currentPath === '/profile' || isOnboarding;
  
  if (!hasProfile && !isProfileExempt) {
    if (currentPath === '/profile') return children;
    return <Navigate to="/profile" state={{ from: location }} replace />;
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  hasToken: PropTypes.bool.isRequired,
  hasProfile: PropTypes.bool.isRequired,
  consent: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  let consent = false;
  if (state.auth.token) {
    try {
      const decoded = jwtDecode(state.auth.token);
      consent = decoded.consent;
    } catch (e) {
    }
  }

  return {
    hasToken: state.auth.hasToken,
    hasProfile: state.auth.hasProfile,
    hasProfiles: state.auth.hasProfiles,
    hasBabies: state.auth.hasBabies,
    consent
  };
}

export default connect(mapStateToProps)(PrivateRoute);